export default {
  zh: {
    exchange: '兑换',
    withdrawal: '目标',
    familyWithdrawal: '家族提现',
    more: '查看更多',
    currentRuby: '当前拥有的红宝石数量',
    toGold: '兑换成金币',
    exNum: '兑换的数量',
    enterExchange: '输入兑换数量',
    getGold: '得到金币',
    withdrawMethod: '提现方式',
    patriarchTrans: '族长转账',
    WithdrawalNum: '提现数量',
    enterWithdrawal: '输入提现数量',
    getMoney: '得到金额',
    progs: '处理中',
    Withdrawallevel: '提现等级',

    micTime: '在麦的时间',
    hadFreeze: '冻结中',
    accu: (time, ruby) => {
      return `累计在麦 ${time} 小时，红宝石提现数量必须 >= ${ruby}`
    },
    handle: '处理',
    gold: '金币',

    waitPro: '等待处理',
    cancel: '取消',
    waiting: '等待',

    must500: '必须是2的倍数!!!',
    exSuc: '兑换成功',
    noTime: '在线时间不足，无法兑换',
    greaterThan: (txt) => {
      return `提现金额必须大于${txt}`
    },
    applySuc: '申请成功，等待处理...',
    handleSuc: '处理成功',
    goBack: '已退回',
    onConfirm: '确定',
    pleaseEnter: '请输入具体数量',
    ruleContent: `Explanation of the Target system:<br/>
    1: The target is upgraded by receiving ruby ​​gifts<br/>
    2: While receiving ruby ​​gifts, the target will be upgraded by 100%, which means receiving a gift worth 1,000 ruby . The target will be upgraded to 1,000 points.<br/>
    3: Receiving ruby ​​gifts results in obtaining 20% of diamonds, so you can spend them on coins without affecting the target.<br/>
    4: The host can withdraw the ruby ​​and add it to the ruby ​​wallet to use again , However this will affect the Target points, as the points will be withdrawn immediately after the draw (according to the amount withdrawn).<br/>
    5: After the withdrawal process, 50% of the withdrawn amount will be added to the ruby wallet, and the discount will be 100%<br/>
    `,
    rules: '规则',
    level: ' 提取等级'
  },
  en: {
    withdrawal: 'Target',
    familyWithdrawal: 'Family',
    more: 'More',
    currentRuby: 'Current number of rubies',
    toGold: 'Convert to gold',
    exNum: 'Amount of exchange',
    enterExchange: 'Enter amount of exchange',
    getGold: 'Gold',
    withdrawMethod: 'method',
    patriarchTrans: 'patriarch transfer money',
    WithdrawalNum: 'quantity',
    enterWithdrawal: 'Enter quantity',
    getMoney: 'dollar',
    progs: 'Processing',
    Withdrawallevel: 'level',
    micTime: 'Total time using microphone',
    hadFreeze: 'Freezing',
    accu: (time, ruby) => {
      return `Accumulated ${time} hours in Mai, ruby withdrawal quantity must be greater than or equal to ${ruby}`
    },
    handle: 'Handle',
    gold: 'gold',

    waitPro: 'Pending processing',
    cancel: 'Cancel',
    waiting: 'wait',

    must500: 'Must be a multiple of 2!!',
    exSuc: 'Exchange succeeded',
    noTime: 'Insufficient online time to redeem',
    greaterThan: (txt) => {
      return `The withdrawal amount must be greater than ${txt}`
    },
    applySuc: 'Application succeeded, waiting for processing...',
    handleSuc: 'Processed successfully',
    goBack: 'Returned',
    onConfirm: 'confirm',
    pleaseEnter: 'Please enter the quantity',
    ruleContent: `Explanation of the Target system:<br/>
    1: The target is upgraded by receiving ruby ​​gifts<br/>
    2: While receiving ruby ​​gifts, the target will be upgraded by 100%, which means receiving a gift worth 1,000 ruby . The target will be upgraded to 1,000 points.<br/>
    3: Receiving ruby ​​gifts results in obtaining 20% of diamonds, so you can spend them on coins without affecting the target.<br/>
    4: The host can withdraw the ruby ​​and add it to the ruby ​​wallet to use again , However this will affect the Target points, as the points will be withdrawn immediately after the draw (according to the amount withdrawn).<br/>
    5: After the withdrawal process, 50% of the withdrawn amount will be added to the ruby wallet, and the discount will be 100%<br/>
    `,
    rules: 'Rules',

    level: ' Level',
    emptyText: 'Oops, no exchange record yet.',
    target: ' Target ',
    total: ' Total ',
    exchangeamount: ' Withdraw Ruby ',
    willget: ' You will get ',
    notenough: 'There are not enough Target！',
    erromsg: 'Target to be ruby are an integer',
    erroGoldmsg: 'Target to be gold are an integer',
    exchange: 'Exchange',
    noChangeMan: "You are not a Host, you don't have Withdraw Ruby Target.",
    nohostTipText: "You are not a Host, you don't have Target"
  },
  ar: {
    withdrawal: 'التارجت ',
    familyWithdrawal: 'سحب القبيلة',
    more: 'أكثر',
    currentRuby: 'عدد الياقوت',
    toGold: 'صرف إلى العملات الذهبية',
    exNum: 'مبلغ الصرف',
    enterExchange: 'أدخل مبلغ الصرف',
    getGold: 'الذهب',
    withdrawMethod: 'طريقة السحب',
    patriarchTrans: 'تحويل زعيم القبيلة',
    WithdrawalNum: 'كمية السحب',
    enterWithdrawal: 'أدخل الكمية',
    getMoney: 'دولار',
    progs: 'قيد المعالجة',
    Withdrawallevel: 'مستوى السحب',
    micTime: 'الوقت الإجمالي لاستخدام الميكروفون',
    hadFreeze: 'كمية الياقوت المجمد',
    accu: (time, ruby) => {
      return `ساعات ${time} المتراكمة في الميكروفون ، يجب أن تكون كمية سحب الياقوت أكبر من أو تساوي ${ruby}`
    },
    handle: 'التعامل',
    gold: 'ذهب',
    waitPro: 'في انتظار المعالجة',
    cancel: 'إلغاء الأمر',
    waiting: 'انتظر',
    must500: '2 !!',
    exSuc: 'نجح الصرف',
    noTime: 'الوقت غير الكافي عبر الإنترنت، لا يمكن الصرف',
    greaterThan: (txt) => {
      return `يجب أن يكون مبلغ السحب أكبر من ${txt}`
    },
    applySuc: 'نجح التطبيق ، في انتظار المعالجة ...',
    handleSuc: 'تمت معالجتها بنجاح',
    goBack: 'عاد',
    onConfirm: 'أكد',
    pleaseEnter: 'الرجاء إدخال عدد',
    ruleContent: `شرح نظام التارجت  : <br/>
    1: يتم ترقية التارجت باستلام هدايا الياقوت <br/>
    2: اثناء استلام هدايا الياقوت يتم ترقية الهدف بنسبة 100% يعني استلام هديه بقيمة 1000 روبي سيتم ترقية التارجت الى 1000 نقطة <br/>
    3: ينتج استلام هدايا الياقوت عن الحصول على 20% من الالماس بحيث يمكنك صرفها الى كونز بدون تأثير على التارجت <br/>
    4: يمكن للمضيف سحب الياقوت و اضافته الى محفظة الياقوت لاستعماله مجددا 
    لكن هذا سيأثر على نقاط التارجت بحيث سيتم سحب النقاط مباشرة بعد السحب ( وفقا للكمية التي تم سحبها ) <br/>
    5 : بعد عملية السحب سيتم اضافة 50% من الكمية التي تم سحبها الى محفظة الياقوت و الخصم سيكون بنسبة 100%`,
    rules: 'القواعد',

    level: 'مستوى السحب',
    emptyText: 'عفوا ، لا يوجد سجل تبادل حتى الآن.',
    target: ' التارجت ',
    total: ' المجموع ',
    amount: ' الكمية ',
    exchangeamount: ' سحب الياقوت',
    willget: 'سوف تحصل على',
    notenough: 'لا يوجد هدف كاف!',
    erromsg: 'الهدف أن يكون روبي عددا صحيحا',
    exchange: 'الكمية',
    erroGoldmsg: 'الهدف أن يكون الذهب عددا صحيحا',
    noChangeMan: 'انت لست مضيف، لا يوجد تارجت خاص بك',
    nohostTipText: 'انت لست مضيف، لا يوجد تارجت خاص بك'
  },
  tr: {
    withdrawal: 'Hedef',
    familyWithdrawal: 'Aile',
    more: 'Daha',
    currentRuby: 'Mevcut yakut sayısı',
    toGold: 'Altınla takas et',
    exNum: 'Değişim miktarı',
    enterExchange: 'Değişim miktarını girin',
    getGold: 'Altın',
    withdrawMethod: 'yöntem',
    patriarchTrans: 'Patrik transfer parası',
    WithdrawalNum: 'miktar',
    enterWithdrawal: 'Miktar girin',
    getMoney: 'dolar',
    progs: 'Işleme',
    Withdrawallevel: 'düzey',
    micTime: 'Mikrofon kullanılarak geçirilen toplam süre',
    hadFreeze: 'Donma',
    accu: (time, ruby) => {
      return `Birkaç saat içinde birikmiş ${time} saat, yakut para çekme miktarı ${ruby} değerinden büyük veya ona eşit olmalıdır`
    },
    handle: 'Kulp',
    gold: 'altın',
    waitPro: 'Bekleyen işlem',
    cancel: 'İptal',
    waiting: 'beklemek',

    must500: "2'nin katı olmalıdır",
    exSuc: 'Değişim başarılı oldu',
    noTime: 'Kullanmak için yetersiz çevrimiçi zaman',
    greaterThan: (txt) => {
      return `Para çekme tutarı ${txt} değerinden büyük olmalıdır`
    },
    applySuc: 'Uygulama başarılı oldu, işlenmeyi bekliyor...',
    handleSuc: 'Başarıyla işlendi',
    goBack: 'Döndürülen',
    onConfirm: 'onaylamak',
    pleaseEnter: 'Lütfen miktarı girin',
    ruleContent: `Kota Sisteminin Açıklaması:<br/>
    1: Kota yakut hediyeleri alarak yükseltilir<br/>
    2. Yakut hediyeleri alırken, Kota %100 yükseltilecek, Örneğin; 1000 yakut değerinde bir hediye almak, Kotanıza 1000 yakut eklenmesi anlamına gelir.<br/>
    3: Yakut hediyeleri almak elmasların % 20'ini elde eder, Böylece onları kotayı  etkilemeden Altına çevirebilir ,harcayabilirsiniz.<br/>
    4: Yayıncı, yakut çekebilir ve tekrar kullanmak için yakut cüzdanına ekleyebilir, Ama bu Kota noktaları etkileyecek, yakutlar çekildikten hemen sonra kotadan düşürülecektir. (çekilen yakut miktarına göre).<br/>
    5: Çekilme sürecinden sonra, Geri çekilen miktarın (Yakut olarak çekilir ise)  %50'si yakut cüzdanına eklenecek, ve kotadan düşüş % 100 olacaktır. `,
    rules: 'Kurallar',

    level: ' Düzey',
    emptyText: 'Oops, henüz değişim kaydı yok.',
    target: ' Hedef ',
    total: ' Toplam ',
    amount: ' Miktar ',
    willget: ' Alacaksın ',
    notenough: 'Yeterli Hedef yok!',
    exchangeamount: 'Yakut Olarak Çek',
    erromsg: 'Yakut olacak hedef bir tamsayıdır',
    exchange: 'Değişim',
    erroGoldmsg: 'Altın olma hedefi bir tamsayıdır',
    noChangeMan: 'Ev sahibi değilsiniz, Ruby Çekme Hedefiniz yok.',
    nohostTipText: 'Yayıncı değilsiniz, Kotanız yok'
  },
  pt: {
    withdrawal: 'Alvo',
    familyWithdrawal: 'Família',
    more: 'Mais',
    currentRuby: 'Número atual de rubis',
    toGold: 'Converter para ouro',
    exNum: 'Quantidade de troca',
    enterExchange: 'Digite a quantidade de troca',
    getGold: 'Ouro',
    withdrawMethod: 'Método',
    patriarchTrans: 'Transferência do patriarca',
    WithdrawalNum: 'Quantidade',
    enterWithdrawal: 'Digite a quantidade',
    getMoney: 'dólar',
    progs: 'Processando',
    Withdrawallevel: 'Nível',
    micTime: 'Tempo total usando o microfone',
    hadFreeze: 'Congelando',
    accu: (time, ruby) => {
      return `Acumulado ${time} horas em Mai, a quantidade de retirada de rubis deve ser maior ou igual a ${ruby}`
    },
    handle: 'Gerenciar',
    gold: 'ouro',
    waitPro: 'Processamento pendente',
    cancel: 'Cancelar',
    waiting: 'aguardando',
    must500: 'Deve ser múltiplo de 2!!',
    exSuc: 'Troca bem-sucedida',
    noTime: 'Tempo online insuficiente para resgatar',
    greaterThan: (txt) => {
      return `A quantidade de retirada deve ser maior que ${txt}`
    },
    applySuc: 'Aplicação bem-sucedida, aguardando processamento...',
    handleSuc: 'Processado com sucesso',
    goBack: 'Voltar',
    onConfirm: 'confirmar',
    pleaseEnter: 'Por favor, insira a quantidade',
    ruleContent: `Explicação do sistema de Alvo:<br/>
    1: O alvo é atualizado recebendo presentes de rubis<br/>
    2: Ao receber presentes de rubis, o alvo será atualizado em 100%, o que significa que ao receber um presente no valor de 1.000 rubis, o alvo será atualizado para 1.000 pontos.<br/>
    3: Receber presentes de rubis resulta na obtenção de 20% de diamantes, para que você possa gastá-los em moedas sem afetar o alvo.<br/>
    4: O anfitrião pode retirar os rubis e adicioná-los à carteira de rubis para usar novamente, no entanto, isso afetará os pontos do alvo, pois os pontos serão retirados imediatamente após o saque (de acordo com a quantidade retirada).<br/>
    5: Após o processo de retirada, 50% da quantidade retirada será adicionada à carteira de rubis, e o desconto será de 100%<br/>`,
    rules: 'Regras',
    level: 'Nível',
    emptyText: 'Oops, ainda não há registros de troca.',
    target: 'Alvo',
    total: 'Total',
    exchangeamount: 'Retirar Rubi',
    willget: 'Você receberá',
    notenough: 'Não há rubis suficientes!',
    erromsg: 'O alvo a ser convertido em rubis deve ser um número inteiro',
    erroGoldmsg: 'O alvo a ser convertido em ouro deve ser um número inteiro',
    exchange: 'Trocar',
    noChangeMan: 'Você não é um anfitrião, não tem Alvo para Retirar Rubis.',
    nohostTipText: 'Você não é um anfitrião, não tem Alvo'
  },
  id: {
    withdrawal: 'Tujuan',
    familyWithdrawal: 'Keluarga',
    more: 'Lebih banyak',
    currentRuby: 'Jumlah ruby saat ini',
    toGold: 'Konversi ke emas',
    exNum: 'Jumlah pertukaran',
    enterExchange: 'Masukkan jumlah pertukaran',
    getGold: 'Emas',
    withdrawMethod: 'Metode',
    patriarchTrans: 'Transfer uang patriark',
    WithdrawalNum: 'Jumlah',
    enterWithdrawal: 'Masukkan jumlah',
    getMoney: 'Dolar',
    progs: 'Proses',
    Withdrawallevel: 'Level',
    micTime: 'Total waktu menggunakan mikrofon',
    hadFreeze: 'Pembekuan',
    accu: (time, ruby) => {
      return `Akumulasi ${time} jam di Mai, jumlah penarikan ruby harus lebih besar dari atau sama dengan ${ruby}`
    },
    handle: 'Tangani',
    gold: 'Emas',

    waitPro: 'Menunggu pemrosesan',
    cancel: 'Batal',
    waiting: 'Menunggu',

    must500: 'Harus kelipatan 2!!',
    exSuc: 'Pertukaran berhasil',
    noTime: 'Waktu online tidak cukup untuk penukaran',
    greaterThan: (txt) => {
      return `Jumlah penarikan harus lebih besar dari ${txt}`
    },
    applySuc: 'Aplikasi berhasil, menunggu pemrosesan...',
    handleSuc: 'Diproses dengan sukses',
    goBack: 'Kembali',
    onConfirm: 'Konfirmasi',
    pleaseEnter: 'Silakan masukkan jumlah',
    ruleContent: `Penjelasan sistem Target:<br/>
    1: Target ditingkatkan dengan menerima hadiah ruby<br/>
    2: Sambil menerima hadiah ruby, target akan ditingkatkan 100%, yang berarti menerima hadiah senilai 1.000 ruby. Target akan ditingkatkan menjadi 1.000 poin.<br/>
    3: Menerima hadiah ruby menghasilkan 20% berlian, jadi Anda bisa menggunakannya untuk koin tanpa mempengaruhi target.<br/>
    4: Host dapat menarik ruby dan menambahkannya ke dompet ruby untuk digunakan lagi, namun ini akan mempengaruhi poin Target, karena poin akan ditarik segera setelah penarikan (sesuai dengan jumlah yang ditarik).<br/>
    5: Setelah proses penarikan, 50% dari jumlah yang ditarik akan ditambahkan ke dompet ruby, dan diskon akan menjadi 100%<br/>
    `,
    rules: 'Aturan',

    level: ' Level',
    emptyText: 'Ups, belum ada catatan pertukaran.',
    target: 'Tujuan',
    total: 'Total',
    exchangeamount: 'Tarik Ruby',
    willget: 'Anda akan mendapatkan',
    notenough: 'Target tidak cukup!',
    erromsg: 'Target untuk ruby harus berupa angka bulat',
    erroGoldmsg: 'Target untuk emas harus berupa angka bulat',
    exchange: 'Tukar',
    noChangeMan: 'Anda bukan Host, Anda tidak memiliki Target Penarikan Ruby.',
    nohostTipText: 'Anda bukan Host, Anda tidak memiliki Target'
  },
  ur: {
    withdrawal: 'ہدف',
    familyWithdrawal: 'خاندان',
    more: 'مزید',
    currentRuby: 'موجودہ روبیوں کی تعداد',
    toGold: 'سونے میں تبدیل کریں',
    exNum: 'تبادلہ کی مقدار',
    enterExchange: 'تبادلہ کی مقدار درج کریں',
    getGold: 'سونا',
    withdrawMethod: 'طریقہ',
    patriarchTrans: 'بزرگ رقم منتقل کریں',
    WithdrawalNum: 'مقدار',
    enterWithdrawal: 'مقدار درج کریں',
    getMoney: 'ڈالر',
    progs: 'پروسیسنگ',
    Withdrawallevel: 'سطح',
    micTime: 'مائیکروفون کے استعمال کا کل وقت',
    hadFreeze: 'منجمد',
    accu: (time, ruby) => {
      return `مئی میں ${time} گھنٹے جمع کیے گئے، روبی نکالنے کی مقدار ${ruby} یا اس سے زیادہ ہونی چاہیے`
    },
    handle: 'ہینڈل',
    gold: 'سونا',

    waitPro: 'زیر التواء پروسیسنگ',
    cancel: 'منسوخ کریں',
    waiting: 'انتظار کریں',

    must500: 'یہ 2 کا ضرب ہونا ضروری ہے!!',
    exSuc: 'تبادلہ کامیاب ہوگیا',
    noTime: 'ریڈیم کرنے کے لیے کافی آن لائن وقت نہیں ہے',
    greaterThan: (txt) => {
      return `نکالنے کی مقدار ${txt} سے زیادہ ہونی چاہیے`
    },
    applySuc: 'درخواست کامیاب، پروسیسنگ کے منتظر...',
    handleSuc: 'کامیابی سے پروسیس ہوگیا',
    goBack: 'واپس آیا',
    onConfirm: 'تصدیق کریں',
    pleaseEnter: 'براہ کرم مقدار درج کریں',
    ruleContent: `ہدف کے نظام کی وضاحت:<br/>
    1: ہدف روبی تحائف وصول کرنے سے اپ گریڈ ہوتا ہے<br/>
    2: روبی تحائف وصول کرتے ہوئے، ہدف 100% اپ گریڈ ہوجائے گا، یعنی 1,000 روبی مالیت کا تحفہ حاصل کرنے سے ہدف 1,000 پوائنٹس تک اپ گریڈ ہوگا۔<br/>
    3: روبی تحائف وصول کرنے کے نتیجے میں 20% ہیرے حاصل ہوتے ہیں، لہذا آپ انہیں سکوں پر خرچ کرسکتے ہیں بغیر ہدف پر اثر ڈالے۔<br/>
    4: میزبان روبی نکال کر روبی والیٹ میں شامل کر سکتا ہے تاکہ دوبارہ استعمال کیا جاسکے، تاہم اس سے ہدف کے پوائنٹس متاثر ہوں گے، کیونکہ نکالنے کے فوراً بعد پوائنٹس نکالے جائیں گے (نکالی گئی مقدار کے مطابق)۔<br/>
    5: نکالنے کے عمل کے بعد، نکالی گئی رقم کا 50% روبی والیٹ میں شامل کیا جائے گا، اور رعایت 100% ہوگی۔<br/>
    `,
    rules: 'قواعد',

    level: 'سطح',
    emptyText: 'اوہ، ابھی تک کوئی تبادلہ ریکارڈ نہیں ہے۔',
    target: 'ہدف',
    total: 'کل',
    exchangeamount: 'روبی نکالیں',
    willget: 'آپ کو ملے گا',
    notenough: 'کافی ہدف نہیں ہے!',
    erromsg: 'روبی میں بدلنے والا ہدف ایک عدد ہونا چاہیے',
    erroGoldmsg: 'سونے میں بدلنے والا ہدف ایک عدد ہونا چاہیے',
    exchange: 'تبادلہ',
    noChangeMan: 'آپ میزبان نہیں ہیں، آپ کے پاس روبی نکالنے کا ہدف نہیں ہے۔',
    nohostTipText: 'آپ میزبان نہیں ہیں، آپ کے پاس ہدف نہیں ہے'
  }
}



// WEBPACK FOOTER //
// src/pages/app/ruby/lang.js